import React, { Component, Fragment, useState } from "react";
import ReactDOM from "react-dom";
import { Table } from "reactstrap";

import moment from "moment";
import 'moment-timezone';
import $ from "jquery";
import "datatables.net-bs4";

import classes from "./Table.module.scss";
import Section from "./../Section/Section";
import Button from "./../Button/Button";
import SectionTitle from "./../SectionTitle/SectionTitle";
import searchIcon from "./../../../assets/icons/search.png";
import TruckImageLightbox from "./../TruckImageLightbox/TruckImageLightbox";

import { Button as _Button } from "reactstrap";
import AddTruckModal from "../AddTruckModal/AddTruckModal";
import { boxiPrimary } from "../../../assets/style/colors";

class SectionTable extends Component {

  constructor(props){
    super(props);
    //this.updateLightbox = this.updateLightbox.bind(this);
    this.state={
      img_urls: [],
      photoIndex: 0,
      isAddTruckModalOpen: false
    }
  }


  linkDataTable(dataLength) {
    // only set table as datatable if there is actual data to show and table isn't already a datatable
    if (dataLength > 0 && !$.fn.dataTable.isDataTable(`#${this.props.id}`)) {
      let table = $(`#${this.props.id}`).DataTable({
        paginate: false,
        responsive: true,
        searching: this.props.noSearch ? false : true,
        bInfo: false,
        scrollY: this.props.maxHeight ? this.props.maxHeight : "none"
      });
      // style search bar only if search is enabled
      if (!this.props.noSearch) {
        // style the search bar wrapper
        let searchBarWrapper = $(`#${this.props.id}_filter`);
        searchBarWrapper.css({
          position: "relative",
          top: "-43px",
          right: "25px"
        });
        searchBarWrapper.parent().parent().css("height", "0");
        // clear default search text
        searchBarWrapper[0].childNodes[0].childNodes[0].data = "";
        // style actual search bar
        let searchBar = searchBarWrapper.children().children();
        this.props.title !== 'Trucks On Campaign' ? searchBar.css({
          borderRadius: "1000px",
          position: "relative",
          left: "-25px",
          width: "100%",
          paddingLeft: "35px"
        }) 
        :
        searchBar.css({
          display: "none"
        }) 
        // on search only tables, display content only when search bar has a value in it
        if (this.props.searchOnly) {
          searchBar.on("input", (e) => {
            $(`#${this.props.id} tbody`).css({
              display: e.target.value ? "contents" : "none"
            });
          });
        }
        let icon = $('<img alt-text="Search Icon" alt="Search Icon" />');
        if (this.props.title !== 'Trucks On Campaign') {
          // insert search icon
          icon.attr("src", searchIcon);
          icon.attr("class", classes.searchIcon);
          searchBarWrapper.children().prepend(icon);
        }
      }
      // recalculate column widths
      table.columns.adjust();
    }
  }

  updateTableBody = (props) => {
    // unlink datatable on body update
    if ($.fn.dataTable.isDataTable(`#${this.props.id}`)) {
      $(`#${this.props.id}`).DataTable().destroy();
    }
    const buttonStyle = {
      fontSize: "14px",
      padding: "3px 5px",
      width: "100%",
      boxSizing: "border-box"
    };
    let idExists = false;
    let headers = props.headers
      ? props.headers.filter((header) => {
          // filter out id header
          if (header === "id") {
            idExists = true;
            return false;
          }
          return true;
        })
      : [];

    let buttonHeaders = [];
    let buttons = [];
    let shift = idExists ? 1 : 0;
    let columnSize = headers.length + shift;
    let body = $(`#${this.props.id}-body`);
    body.empty();
    if (this.props.searchOnly) {
      body.css({
        display: "none"
      });
    }
    // loop through rows of data
    for (let index = 0; index < props.data.length; index++) {
      let row = $(`<tr key=${index}>`);
      row.append($(`<td style="'width': '15px', 'padding-right': '30px'" key=${index}>${index + 1}</td>`));
      // loop through columns in a single row and add them
      // console.log(`${this.props.id}\n${props.data[index]}`);
      for (let i = shift; i < columnSize; i++) {
        if (typeof props.data[index][i] === "boolean") {
          let status = props.data[index][i];
          let checkbox = `<label class="${classes.checkboxContainer}"><input type="checkbox" disabled ${
            status ? "checked" : ""
          } /><span class="${classes.checkboxLabel}">${status ? "Yes" : "No"}</span><span class="${
            classes.checkmark
          }"></span></label>`;
          row.append($(`<td key="${headers[i - shift]}-${index}">${checkbox}</td>`));
        }
        else if (props.data[index][i] && typeof props.data[index][i].boolvalue === "boolean" && props.data[index][i].boollabel){
          let status = props.data[index][i].boolvalue;
          let checkbox = `<label class="${classes.checkboxContainer}"><input type="checkbox" disabled ${
            status ? "checked" : ""
          } /><span class="${classes.checkboxLabel}">${props.data[index][i].boollabel}</span><span class="${
            classes.checkmark
          }"></span></label>`;
          row.append($(`<td key="${headers[i - shift]}-${index}">${checkbox}</td>`));
        }
        else if (typeof props.data[index][i] === "string" && props.data[index][i].toLowerCase().match(/\.(jpeg|jpg|gif|png|tiff|heic)$/) != null) {
          let img_html = `<img class="${classes.truckImage}" src="${props.data[index][i]}" />`;
          row.append($(`<td key="${headers[i - shift]}-${index}">${img_html}</td>`));

          let joined_urls = this.state.img_urls;
          joined_urls.push(props.data[index][i]);
          console.log(joined_urls);
          this.setState({
            img_urls: joined_urls,
          });
        }
        else if (typeof props.data[index][i] !== "string" && moment.isMoment(props.data[index][i])){ 
          let date = moment(props.data[index][i]).format("MM/DD/YYYY h:m:s a");
          row.append($(`<td key="${headers[i - shift]} - ${index}">${date}</td>`));
        }
        else {
          row.append($(`<td key="${headers[i - shift]}-${index}">${props.data[index][i] ? props.data[index][i] : ""}</td>`));
        }
      }
      // add any buttons to display in table
      if (props.buttons) {
        props.buttons.map((button) => {
          // on first iteration, push button column header
          if (index === 0) buttonHeaders.push($(`<th key=${button.display}>${button.display}</th>`));
          let elementId = `${this.props.id}-${button.display.split(" ").join("-")}-button-${index}`;
          // insert button as row column entry
          row.append($(`<td key="${button.display}-${index}" id=${elementId}></td>`));
          let id = idExists ? props.data[index][0] : null;
          // if it doesn't, then return to skip current iteration
          if (id) {
            let click = button.onClickHandler
              ? (e) => {
                  e.preventDefault();
                  button.onClickHandler(index, id);
                }
              : null;
            buttons.push([
              elementId,
              <Button click={click} path={button.path} colors={button.display.includes('Edit') || button.display.includes('Add') || button.display.includes('View') ? [boxiPrimary] : button.display == 'Delete' ? ["#dc3545"] : ["#03A9F4"]} style={buttonStyle} noShadow>
                {button.display}
              </Button>
            ]);
          } else {
            buttons.push([elementId, <div className={classes.buttonReplaceText}>Save to {button.display.toLowerCase()}</div>]);
          }
        });
      }
      body.append(row);
    }
    for (let button of buttons) {
      ReactDOM.render(button[1], $(`#${button[0]}`)[0]);
    }
    // insert headers
    let tableHeader = $(`#${this.props.id}-header-row`);
    tableHeader.empty();
    tableHeader.append($(`<th style="'width': '15px'" key="#">#</th>`));
    headers.map((header) => {
      tableHeader.append($(`<th key=${header}>${header}</th>`));
    });
    // add button headers
    buttonHeaders.map((button) => {
      tableHeader.append(button);
      tableHeader.css({
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8
      })
    });
  };


  shouldComponentUpdate(nextProps) {
    if (!dataIsEqual(this.props.data, nextProps.data)) {
      this.updateTableBody(nextProps);
      this.linkDataTable(nextProps.data.length);
    }
    //must return true in order to pass the new props to the lightbox component
    //otherwise lightbox will not show
    return true;
  }

  openModal = () => {
    this.setState({
      isAddTruckModalOpen: true
    })
  }

  closeModal = () => {
    this.setState({
      isAddTruckModalOpen: false
    })
  }

  render() {
    const tableBodyStyle = { display: this.props.searchOnly ? "none" : "contents" };
    // determine and set colors
    let colors = this.props.colors ? this.props.colors : ["#329d9c", "#cff4d2"];
    let tableStyle = {
      backgroundColor: colors[0]
    };
    // if title is provided, insert with styling
    let title = null;
    if (this.props.title) {
      // title = (
      //   <SectionTitle colors={colors}>
      //     {this.props.title}
      //     {this.props.searchOnly ? " (Search to Populate)" : ""}
      //   </SectionTitle>
      // );
      title = (
        <div className={classes.title}>
          {this.props.title}
          {this.props.searchOnly ? " (Search to Populate)" : ""}
        </div>
      );
      tableStyle = {
        ...tableStyle,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        marginTop: 0
      };
    }

    return (
      <>
        {this.state.isAddTruckModalOpen && <AddTruckModal isEditing={false} isModalOpen={this.state.isAddTruckModalOpen} openModal={this.closeModal} trucks={this.props.available_trucks} placeholders={this.props.available_placeholders} addCampaignTruck={this.props.addCampaignTruck} />}
        <div style={this.props.sectionStyle} className={classes.tableCard}>
          {title}
          {this.props.title === 'Trucks On Campaign' && 
            <_Button disabled={this.props.available_trucks.length === 0 || this.props.available_placeholders.length === 0} className={classes.primaryButton} onClick={this.openModal}>
              Add Truck
            </_Button>
          }
          {this.props.isLoading && <div style={{ backgroundColor: "white", borderRadius: "8px", padding: "20px" }}>
            <div style={{ fontSize: 12, color: "gray", textAlign: "center" }}><span className={classes.loader}></span>{this.props.loadingText}</div>
          </div>}
          <div className={classes.tableContainer}>
            <Table id={this.props.id} className={classes.table} style={this.props.tableStyle}>
              <thead style={{ backgroundColor: '#F0F2F4', borderRadius: 8}}>
                <tr id={`${this.props.id}-header-row`}></tr>
              </thead>
              <tbody id={`${this.props.id}-body`} style={tableBodyStyle}></tbody>
            </Table>
          </div>
          {this.props.enableLightbox && (
          <TruckImageLightbox
          data = {this.state.img_urls}
          photoIndex = {this.props.lightboxIndex}
          isOpen = {this.props.showLightbox} />
        )}
        </div>
      </>
    );
  }
}

function dataIsEqual(a, b) {
  if (a.length !== b.length) {
    return false;
  }
  a.sort((x, y) => (x[0] === y[0] ? 0 : x[0] < y[0] ? -1 : 1));
  b.sort((x, y) => (x[0] === y[0] ? 0 : x[0] < y[0] ? -1 : 1));
  for (let i = 0; i < a.length; i++) {
    if (a[i].length !== b[i].length) {
      return false;
    }
    for (let j = 0; j < a[i].length; j++) {
      if (a[i][j] !== b[i][j]) {
        return false;
      }
    }
  }
  return true;
}

export default SectionTable;
